const serverUrl = process.env.PENTA_MASTER_SERVER_URL || `https://${window.location.hostname}/api/`;

export const USERS_INIT_FORM = serverUrl + 'user/users/init-form';
export const USERS_INIT_UPDATE_FORM = serverUrl + 'user/users/init-update-form/';
export const USERS_GET_ALL_RECORDS = serverUrl + 'user/users/get-all-records';
export const USERS_REGISTER = serverUrl + 'user/users/register';
export const USERS_UPDATE = serverUrl + 'user/users/update/';
export const USERS_DELETE = serverUrl + 'user/users/delete?';